import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/sidebar";
import ThemeToggle from "../components/ThemeToggle";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  return (
    <div
      className="
        min-h-screen 
        bg-[#F8FAFC]
        dark:bg-[#0F172A]
        bg-light-bg 
        dark:bg-dark-bg
        bg-cover bg-no-repeat bg-top
        tabletpro:px-10 tabletair:px-4 tabletmini:px-4 mobile:px-4
      "
    >
      {/* Header */}
      <div className="relative z-[60]">
        <Header onMenuClick={toggleSidebar} />
      </div>

      <div className="pt-[56px] tabletpro:pt-[79px] desktop:pt-[79px] max-w-[1400px] mx-auto">
        {/* Sidebar mobile */}
        <div className=" desktop:hidden w-full mt-[1%]">
          {sidebarOpen && (
            <div className="w-full px-4 mb-3 tabletpro:mb-0 tabletpro:px-0 tabletair:px-7 tabletmini:px-4 mobile:px-4">
              <Sidebar isMobile />
            </div>
          )}
        </div>

        <div className="max-w-[1400px] mx-auto flex px-4 tabletpro:px-0 desktop:px-0">
          {/* Sidebar desktop */}
          <aside className="hidden desktop:block h-[calc(100vh-79px)] sticky top-[79px] pt-[1%]">
            <Sidebar />
          </aside>

          {/* Content + ThemeToggle bên phải */}
          <div className="flex-1 flex gap-4 desktop:pl-4 pb-[2%]">
            <main className="flex-1 tabletair:px-4 tabletmini:px-2 mobile:mt-2 pt-[3%] tabletpro:pb-[3%]">
              {children}
            </main>

            {/* ThemeToggle dạng sticky cho tablet/desktop */}
            <div className="hidden desktop:block">
              <div className="sticky top-[88px]">
                <ThemeToggle />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ThemeToggle mobile – nằm dưới content, canh phải */}
      <div className="flex desktop:hidden px-4 pb-4 ">
        <div className="ml-auto ">
          <ThemeToggle />
        </div>
      </div>

    </div>
  );
};

export default MainLayout;
